import { extra, primary } from '@/theme/colors/palettes';
import { Button, Flex, Image, Text } from '@chakra-ui/react';

type Props = { label: string; count?: number; max?: number; onChange: (count: number) => void };

const NumericChip = ({ label, count = 0, max = Number.MAX_SAFE_INTEGER, onChange }: Props) => {
  const selected = count > 0;

  return (
    <Flex
      align="center"
      gap={2}
      bg={selected ? primary[500] : extra.white}
      color={selected ? extra.white : primary[500]}
      borderRadius="full"
      pl={4}
      pr={2}
      maxH="42px"
      boxShadow={selected ? `0 2px 6px ${primary[500]}55` : `0 2px 3px ${extra.mediumBlue5pct}`}
      border="2px solid"
      borderColor={selected ? primary[300] : 'transparent'}
    >
      <Text fontWeight={800} fontSize="14px">
        {label}
      </Text>
      {selected && (
        <>
          <Button
            variant="unstyled"
            minW="22px"
            h="40px"
            aria-label={`Decrease ${label}`}
            onClick={() => onChange(count - 1)}
            display="inline-flex"
            alignItems="center"
            justifyContent="center"
          >
            <Image src="/svg/buttonMinus.svg" alt={label} objectFit="contain" boxSize="18px" />
          </Button>
          <Text
            as="span"
            aria-live="polite"
            fontWeight={900}
            fontSize="12px"
            lineHeight={'20px'}
            bg={extra.white}
            color={primary[500]}
            borderRadius="full"
            width="20px"
            height={'20px'}
            textAlign="center"
          >
            {count}
          </Text>
        </>
      )}
      <Button
        variant="unstyled"
        minW="22px"
        h="40px"
        aria-label={`Increase ${label}`}
        isDisabled={count >= max}
        onClick={() => onChange(count + 1)}
        display="inline-flex"
        alignItems="center"
        justifyContent="center"
      >
        <Image
          src={selected ? '/svg/buttonPlus.svg' : '/svg/buttonPlusPurple.svg'}
          alt={label}
          objectFit="contain"
          boxSize="16px"
        />
      </Button>
    </Flex>
  );
};

export default NumericChip;
